var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/consents/RWEConsent.tsx";
import React, { useCallback, useState } from 'react';
import { VStack } from '@adc/parallax-component-library';
import { useApiError, usePartner } from 'Hooks';
import { Button, Footer, Header, LogoActionBar, Main, RichText, ScrollContainer, Spinner } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { updateConsent } from 'Services/consent';
const RWEConsent = () => {
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    onConsentsUpdate
  } = usePartner();
  const handleSubmitResearchAction = useCallback(async action => {
    try {
      setLoading(true);
      const authSession = getAuthSession();
      const {
        app
      } = store.getState().env;
      if (authSession) {
        await updateConsent(authSession.accountId, action, app, 'realWorldEvidence', authSession.accessToken);
        onConsentsUpdate();
        return;
      }
      showApiErrorModal();
    } catch {
      showApiErrorModal();
      setLoading(false);
    }
  }, [onConsentsUpdate, showApiErrorModal]);
  const handleLinkClick = useCallback(href => {
    mediator.publish('router:navigate', href);
  }, []);
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(LogoActionBar, {
    titleTestID: "Research.actionTitle",
    title: i18n.t('Research.title'),
    noActionButton: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Header, {
    testID: "Research.title",
    title: i18n.t('Research.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(RichText, {
    onPressLink: handleLinkClick,
    text: i18n.t('Research.content.researchRichText.bodyText'),
    testID: "Research.content.researchRichText.bodyText",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    customProps: /*#__PURE__*/React.createElement(VStack, {
      padding: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onPress: () => handleSubmitResearchAction('accept'),
      testID: "RWE.optIn",
      label: i18n.t('Global.microcopy.common.optIn'),
      "aria-label": i18n.t('Global.microcopy.common.optIn'),
      marginBottom: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      testID: "Global.microcopy.common.decline",
      label: i18n.t('Global.microcopy.common.decline'),
      "aria-label": i18n.t('Global.microcopy.common.decline'),
      onPress: () => handleSubmitResearchAction('decline'),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 94,
        columnNumber: 13
      }
    })),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 7
    }
  }));
};
export default RWEConsent;